import { ActionReducerMap } from "@ngrx/store";

import { AuthenticationState, authenticationReducer } from "./Authentication/authentication.reducer";

import { ChatReducer, ChatState } from "./Chat/chat.reducer";

import { LayoutState, layoutReducer } from "./layouts/layouts.reducer";



export interface RootReducerState {
    layout: LayoutState;
    auth: AuthenticationState;




    chatList: ChatState;

}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    auth: authenticationReducer,



    chatList: ChatReducer,

}